import {types, flow} from 'mobx-state-tree';
import PromoteListingModel from '../PromoteListingModel';
import * as api from '../../services/api';

// tslint:disable

const PromoteListingDetailModel = types
  .model('PromoteListingDetailModel', {
    isLoading: types.optional(types.boolean, false),
    listing: types.maybe(PromoteListingModel)
  })
  .actions(self => ({
    getListing: flow(function*(listingId: number) {
      self.isLoading = true;
      const response = yield api.getPromoteListing(listingId);
      if (response && response.data && response.data.listing) {
        const listing = response.data.listing;
        self.listing = listing;
      }
      self.isLoading = false;
    }),
    updateListing: flow(function*(
      listingId: number,
      data: any,
      callback: any
    ) {
      self.isLoading = true;
      const response = yield api.updatePromoteListing(listingId, data);
      if (response && response.status === 200) {
        const listing = response.data.listing;
        self.listing = listing;
        callback(false, 'Update successfully');
      } else {
        callback(true, 'Update successfully');
      }
      self.isLoading = false;
    }),
    createListing: flow(function*(data: any, callback: any) {
      self.isLoading = true;
      const response = yield api.createPromoteListing(data);
      if (response && response.data && response.data.listing) {
        const listing = response.data.listing;
        self.listing = listing;
        callback(false, 'Creating successfully');
      } else {
        callback(true, 'Creating failed');
      }
      self.isLoading = false;
    })
  }));

export type PromoteListingDetailModelType = typeof PromoteListingDetailModel.Type;
export default PromoteListingDetailModel;



// WEBPACK FOOTER //
// ./src/models/PromoteListingDetailModel/PromoteListingDetailModel.ts